import {c, color, theme, is_mobile} from './modules/settings.js';

(function ($) {
  jQuery(document).ready(function($) {
    $('.js-target-blank').each(function() {
      $(this).attr("target","_blank");
   });
   
  });
})(jQuery);